import { render, staticRenderFns } from "./SensorManagementEvent.vue?vue&type=template&id=afcc819c&scoped=true"
import script from "./SensorManagementEvent.vue?vue&type=script&lang=js"
export * from "./SensorManagementEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcc819c",
  null
  
)

export default component.exports